export const BRAND = {
  name: "Six Figure Couponer",
  founder: "Toni",
  tagline: "We help high earners learn the art of couponing.",
  founderImage:
    "https://customer-assets.emergentagent.com/job_269fdf55-7c8a-445a-a47e-92fd4e98c9e1/artifacts/xag2d4n4_Image.jpeg",
  calendly: "https://calendly.com/toniisgolden/30min",
};

export const SERVICES = [
  {
    id: "two-hour-course",
    name: "The 2-Hour Couponing Course",
    tagline: "Private, on-the-record. A clean, repeatable system you can run from your kitchen table.",
    price: 20,
    priceLabel: "$20",
    priceNote: "One-time payment · Lifetime access",
    duration: "2 hours · self-paced replay included",
    badge: "Most Popular",
    bullets: [
      "The exact rotation that pulls $400+ in groceries for under $40",
      "The three apps every six-figure couponer stacks (and the one to skip)",
      "How to coupon without ever looking like you're clipping",
      "Live walkthrough of a real Publix, Target, and CVS run",
    ],
  },
  {
    id: "digital-products",
    name: "The Digital Vault",
    tagline: "Plug-and-play digital products — printable planners, deal trackers, and the master rotation calendar.",
    price: 27,
    priceLabel: "From $27",
    priceNote: "Instant download · Updated monthly",
    duration: "Delivered to your inbox in minutes",
    badge: "Best for Starters",
    bullets: [
      "The Monthly Rotation Calendar (the same one I personally run)",
      "Printable deal-stack planner — works in any binder",
      "Brand-name pantry & beauty checklist (worth $200+ per trip)",
      "Free updates every quarter — no upsells, ever",
    ],
  },
];

export const TESTIMONIALS = [
  {
    name: "Denise W.",
    location: "Atlanta, GA",
    role: "Pharmaceutical Sales Director",
    quote:
      "I make a quarter-million a year and still cried the first time I walked out with $612 worth of groceries for $38. Toni doesn't teach extreme couponing — she teaches taste.",
  },
  {
    name: "Marisol R.",
    location: "Houston, TX",
    role: "Founder, Boutique Real Estate Firm",
    quote:
      "Most couponing content feels embarrassing. This felt like a private dinner with someone who actually understood my closet, my calendar, and my standards.",
  },
  {
    name: "Karen J.",
    location: "Chicago, IL",
    role: "Senior Counsel, Fortune 500",
    quote:
      "I redirected what I save every month into our Lisbon trip fund. Two years in, the entire family flew business class on couponing money. That's the whole testimonial.",
  },
];
